import { useEffect, useState } from 'react'
import { useSite } from '../useSite'
import { getSiteContacts, addContactToSite, removeContactFromSite, getContacts } from '@/services/site.service'
import { Box, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Select, MenuItem } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

const ContactsPage = () => {
    const { site } = useSite()
    const { t } = useTranslation('site', { keyPrefix: 'contacts' })
    const [contacts, setContacts] = useState([])
    const [allContacts, setAllContacts] = useState([])
    const [open, setOpen] = useState(false)
    const [selectedContact, setSelectedContact] = useState('')

    const init = async () => {
        const res = await getSiteContacts(site.hash)
        if (res) setContacts(res)
        const list = await getContacts()
        if (list) setAllContacts(list)
    }

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [site.hash])

    const handleAdd = async () => {
        if (!selectedContact) return
        await addContactToSite(site.hash, selectedContact)
        setOpen(false)
        setSelectedContact('')
        init()
    }

    const handleRemove = async (contactId) => {
        await removeContactFromSite(site.hash, contactId)
        init()
    }

    return (
        <Box>
            <Box sx={{ textAlign: 'right', mb: 1 }}>
                <IconButton onClick={() => setOpen(true)}>
                    <AddIcon />
                </IconButton>
            </Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {contacts.map((c) => (
                        <TableRow key={c.ContactId}>
                            <TableCell>{c.FirstName}</TableCell>
                            <TableCell>{c.LastName}</TableCell>
                            <TableCell>{c.Email}</TableCell>
                            <TableCell>
                                <IconButton onClick={() => handleRemove(c.ContactId)}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>{t('add')}</DialogTitle>
                <DialogContent>
                    <Select fullWidth value={selectedContact} onChange={(e) => setSelectedContact(e.target.value)}>
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {allContacts.map((c) => (
                            <MenuItem key={c.ContactId} value={c.ContactId}>
                                {c.FirstName} {c.LastName}
                            </MenuItem>
                        ))}
                    </Select>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleAdd} startIcon={<AddIcon />}>Add</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ContactsPage
